export default __webpack_public_path__ + "static/media/partners3.47a6fe6e.png";